import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=81b7202a&scoped=true"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"
import style0 from "./OrganizationProfile.vue?vue&type=style&index=0&id=81b7202a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7202a",
  null
  
)

export default component.exports